import { Link, Stack, Typography } from '@mui/material';

import ArrowRightIcon from '@/components/Icons/ArrowRightIcon';
import BookOpenIcon from '@/components/Icons/BookOpenIcon';
import CloudIcon from '@/components/Icons/CloudIcon';
import ZapIcon from '@/components/Icons/ZapIcon';
import { links } from '@/localization';

import FeatureItem from './FeatureItem/FeatureItem';

function About() {
  return (
    <Stack
      direction="column"
      spacing={4}
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ maxWidth: 400 }}
      mx={{ xs: 0, md: 4 }}
    >
      <Stack gap={2}>
        <Typography variant="h3">
          Scale your mission-critical inference on{' '}
          <Typography variant="h3" color="text.success" component="span">
            our cloud
          </Typography>{' '}
          or{' '}
          <Typography variant="h3" color="text.success" component="span">
            yours
          </Typography>
        </Typography>
        <Typography variant="body1" color="text.muted">
          Get performant model runtimes, cross-cloud high availability, and seamless developer
          workflows. Powered by the Baseten Inference Stack.
        </Typography>
      </Stack>
      <Stack gap={2}>
        <FeatureItem
          icon={<BookOpenIcon color="success" />}
          title="Apply frontier research"
          description="for the best model performance in production."
        />
        <FeatureItem
          icon={<CloudIcon color="success" />}
          title="Deploy anywhere "
          description="with cloud-native infra that won&#39;t break at scale."
        />
        <FeatureItem
          icon={<ZapIcon color="success" />}
          title="Streamline workflows"
          description="with dev tools designed for inference."
        />
        <FeatureItem
          icon={<ArrowRightIcon color="success" />}
          title="Leverage on-demand experts"
          description="to get to market fast."
        />
      </Stack>
      <Typography variant="body1" color="text.muted">
        Want to learn more or need help? Schedule time to{' '}
        <Link href={links.basetenContactUs} target="_blank">
          talk to our engineers.
        </Link>
      </Typography>
    </Stack>
  );
}

export default About;
